import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class TableHeaderRenderer extends PureComponent {

  static defaultProps = {
    value: "",
    className: "align-items-left text-capitalize",
    sortable: false,
    sortIconClassName: "fas fa-sort float-right",
    sortIconPosition: "after"
  };

  render() {
    const { value = "", className = "", sortable = false, sortIconClassName = "", sortIconPosition = "after", textClassName="", ...restProps } = this.props;

    return (
      <div className={`${(className || "")} ${(sortable || false) === true ? "cursor-pointer" : ""}`} {...restProps}>

        {(((sortable || false) === true) && ((sortIconPosition || "") === "before")) && (
          <i className={(sortIconClassName || "")} />
        )}

        <span className={(textClassName || "")}>{(value || "")}</span>

        {(((sortable || false) === true) && ((sortIconPosition || "") === "after")) && (
          <i className={(sortIconClassName || "")} />
        )}

      </div>
    )
  }
}

TableHeaderRenderer.propTypes = {
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  sortable: PropTypes.bool,
  sortIconPosition: PropTypes.string,
  sortIconClassName: PropTypes.string,
};

export default TableHeaderRenderer;
